import React from 'react';
import { Card, CardBody, CardHeader, Col, Container, Row } from 'reactstrap';
import BreadCrumb from '../../../Components/Common/BreadCrumb';

// Imported Images
import pac from '../../../assets/images/svg/crypto-icons/$pac.svg';
import c0xbtc from '../../../assets/images/svg/crypto-icons/0xbtc.svg';
import c2give from '../../../assets/images/svg/crypto-icons/2give.svg';
import aave from '../../../assets/images/svg/crypto-icons/aave.svg';
import abt from '../../../assets/images/svg/crypto-icons/abt.svg';
import act from '../../../assets/images/svg/crypto-icons/act.svg';
import actn from '../../../assets/images/svg/crypto-icons/actn.svg';
import ada from '../../../assets/images/svg/crypto-icons/ada.svg';
import add from '../../../assets/images/svg/crypto-icons/add.svg';
import adx from '../../../assets/images/svg/crypto-icons/adx.svg';
import ae from '../../../assets/images/svg/crypto-icons/ae.svg';
import aeon from '../../../assets/images/svg/crypto-icons/aeon.svg';
import aeur from '../../../assets/images/svg/crypto-icons/aeur.svg';
import agi from '../../../assets/images/svg/crypto-icons/agi.svg';
import agrs from '../../../assets/images/svg/crypto-icons/agrs.svg';
import aion from '../../../assets/images/svg/crypto-icons/aion.svg';
import algo from '../../../assets/images/svg/crypto-icons/algo.svg';
import amb from '../../../assets/images/svg/crypto-icons/amb.svg';
import amp from '../../../assets/images/svg/crypto-icons/amp.svg';
import ampl from '../../../assets/images/svg/crypto-icons/ampl.svg';
import ankr from '../../../assets/images/svg/crypto-icons/ankr.svg';
import ant from '../../../assets/images/svg/crypto-icons/ant.svg';
import apex from '../../../assets/images/svg/crypto-icons/apex.svg';
import appc from '../../../assets/images/svg/crypto-icons/appc.svg';
import ardr from '../../../assets/images/svg/crypto-icons/ardr.svg';
import arg from '../../../assets/images/svg/crypto-icons/arg.svg';
import ark from '../../../assets/images/svg/crypto-icons/ark.svg';
import arn from '../../../assets/images/svg/crypto-icons/arn.svg';
import arnx from '../../../assets/images/svg/crypto-icons/arnx.svg';
import ary from '../../../assets/images/svg/crypto-icons/ary.svg';
import ast from '../../../assets/images/svg/crypto-icons/ast.svg';
import atm from '../../../assets/images/svg/crypto-icons/atm.svg';
import atom from '../../../assets/images/svg/crypto-icons/atom.svg';
import audr from '../../../assets/images/svg/crypto-icons/audr.svg';
import auto from '../../../assets/images/svg/crypto-icons/auto.svg';
import aywa from '../../../assets/images/svg/crypto-icons/aywa.svg';
import bab from '../../../assets/images/svg/crypto-icons/bab.svg';
import bal from '../../../assets/images/svg/crypto-icons/bal.svg';
import band from '../../../assets/images/svg/crypto-icons/band.svg';
import bat from '../../../assets/images/svg/crypto-icons/bat.svg';
import bay from '../../../assets/images/svg/crypto-icons/bay.svg';
import bcbc from '../../../assets/images/svg/crypto-icons/bcbc.svg';
import bcc from '../../../assets/images/svg/crypto-icons/bcc.svg';
import bcd from '../../../assets/images/svg/crypto-icons/bcd.svg';
import bch from '../../../assets/images/svg/crypto-icons/bch.svg';
import bcio from '../../../assets/images/svg/crypto-icons/bcio.svg';
import bcn from '../../../assets/images/svg/crypto-icons/bcn.svg';
import bco from '../../../assets/images/svg/crypto-icons/bco.svg';
import bcpt from '../../../assets/images/svg/crypto-icons/bcpt.svg';
import bdl from '../../../assets/images/svg/crypto-icons/bdl.svg';
import beam from '../../../assets/images/svg/crypto-icons/beam.svg';
import bela from '../../../assets/images/svg/crypto-icons/bela.svg';
import bix from '../../../assets/images/svg/crypto-icons/bix.svg';
import blcn from '../../../assets/images/svg/crypto-icons/blcn.svg';
import blk from '../../../assets/images/svg/crypto-icons/blk.svg';
import block from '../../../assets/images/svg/crypto-icons/block.svg';
import blz from '../../../assets/images/svg/crypto-icons/blz.svg';
import bnb from '../../../assets/images/svg/crypto-icons/bnb.svg';
import bnt from '../../../assets/images/svg/crypto-icons/bnt.svg';
import bnty from '../../../assets/images/svg/crypto-icons/bnty.svg';
import booty from '../../../assets/images/svg/crypto-icons/booty.svg';
import bos from '../../../assets/images/svg/crypto-icons/bos.svg';
import bpt from '../../../assets/images/svg/crypto-icons/bpt.svg';
import bq from '../../../assets/images/svg/crypto-icons/bq.svg';
import brd from '../../../assets/images/svg/crypto-icons/brd.svg';
import bsd from '../../../assets/images/svg/crypto-icons/bsd.svg';
import bsv from '../../../assets/images/svg/crypto-icons/bsv.svg';
import btc from '../../../assets/images/svg/crypto-icons/btc.svg';
import btcd from '../../../assets/images/svg/crypto-icons/btcd.svg';
import btch from '../../../assets/images/svg/crypto-icons/btch.svg';
import btcp from '../../../assets/images/svg/crypto-icons/btcp.svg';
import btcz from '../../../assets/images/svg/crypto-icons/btcz.svg';
import btdx from '../../../assets/images/svg/crypto-icons/btdx.svg';
import btg from '../../../assets/images/svg/crypto-icons/btg.svg';
import btm from '../../../assets/images/svg/crypto-icons/btm.svg';
import bts from '../../../assets/images/svg/crypto-icons/bts.svg';
import btt from '../../../assets/images/svg/crypto-icons/btt.svg';
import btx from '../../../assets/images/svg/crypto-icons/btx.svg';
import burst from '../../../assets/images/svg/crypto-icons/burst.svg';
import bze from '../../../assets/images/svg/crypto-icons/bze.svg';
import call from '../../../assets/images/svg/crypto-icons/call.svg';
import cc from '../../../assets/images/svg/crypto-icons/cc.svg';
import cdn from '../../../assets/images/svg/crypto-icons/cdn.svg';
import cdt from '../../../assets/images/svg/crypto-icons/cdt.svg';
import cenz from '../../../assets/images/svg/crypto-icons/cenz.svg';
import chain from '../../../assets/images/svg/crypto-icons/chain.svg';
import chat from '../../../assets/images/svg/crypto-icons/chat.svg';
import chips from '../../../assets/images/svg/crypto-icons/chips.svg';
import chsb from '../../../assets/images/svg/crypto-icons/chsb.svg';
import cix from '../../../assets/images/svg/crypto-icons/cix.svg';
import clam from '../../../assets/images/svg/crypto-icons/clam.svg';
import cloak from '../../../assets/images/svg/crypto-icons/cloak.svg';
import cmm from '../../../assets/images/svg/crypto-icons/cmm.svg';
import cmt from '../../../assets/images/svg/crypto-icons/cmt.svg';
import cnd from '../../../assets/images/svg/crypto-icons/cnd.svg';
import cnx from '../../../assets/images/svg/crypto-icons/cnx.svg';
import cny from '../../../assets/images/svg/crypto-icons/cny.svg';
import cob from '../../../assets/images/svg/crypto-icons/cob.svg';
import colx from '../../../assets/images/svg/crypto-icons/colx.svg';
import comp from '../../../assets/images/svg/crypto-icons/comp.svg';
import coqui from '../../../assets/images/svg/crypto-icons/coqui.svg';
import cred from '../../../assets/images/svg/crypto-icons/cred.svg';
import crpt from '../../../assets/images/svg/crypto-icons/crpt.svg';
import crv from '../../../assets/images/svg/crypto-icons/crv.svg';
import crw from '../../../assets/images/svg/crypto-icons/crw.svg';
import cs from '../../../assets/images/svg/crypto-icons/cs.svg';
import ctr from '../../../assets/images/svg/crypto-icons/ctr.svg';
import ctxc from '../../../assets/images/svg/crypto-icons/ctxc.svg';
import cvc from '../../../assets/images/svg/crypto-icons/cvc.svg';
import d from '../../../assets/images/svg/crypto-icons/d.svg';
import dai from '../../../assets/images/svg/crypto-icons/dai.svg';
import dash from '../../../assets/images/svg/crypto-icons/dash.svg';
import dat from '../../../assets/images/svg/crypto-icons/dat.svg';
import data from '../../../assets/images/svg/crypto-icons/data.svg';
import dbc from '../../../assets/images/svg/crypto-icons/dbc.svg';
import dcn from '../../../assets/images/svg/crypto-icons/dcn.svg';
import dcr from '../../../assets/images/svg/crypto-icons/dcr.svg';
import deez from '../../../assets/images/svg/crypto-icons/deez.svg';
import dent from '../../../assets/images/svg/crypto-icons/dent.svg';
import dew from '../../../assets/images/svg/crypto-icons/dew.svg';
import dgb from '../../../assets/images/svg/crypto-icons/dgb.svg';
import dgd from '../../../assets/images/svg/crypto-icons/dgd.svg';
import dlt from '../../../assets/images/svg/crypto-icons/dlt.svg';
import dnt from '../../../assets/images/svg/crypto-icons/dnt.svg';
import dock from '../../../assets/images/svg/crypto-icons/dock.svg';
import doge from '../../../assets/images/svg/crypto-icons/doge.svg';
import dot from '../../../assets/images/svg/crypto-icons/dot.svg';
import drgn from '../../../assets/images/svg/crypto-icons/drgn.svg';
import drop from '../../../assets/images/svg/crypto-icons/drop.svg';
import dta from '../../../assets/images/svg/crypto-icons/dta.svg';
import dth from '../../../assets/images/svg/crypto-icons/dth.svg';
import dtr from '../../../assets/images/svg/crypto-icons/dtr.svg';
import ebst from '../../../assets/images/svg/crypto-icons/ebst.svg';
import eca from '../../../assets/images/svg/crypto-icons/eca.svg';
import edg from '../../../assets/images/svg/crypto-icons/edg.svg';
import edo from '../../../assets/images/svg/crypto-icons/edo.svg';
import edoge from '../../../assets/images/svg/crypto-icons/edoge.svg';
import ela from '../../../assets/images/svg/crypto-icons/ela.svg';
import elec from '../../../assets/images/svg/crypto-icons/elec.svg';
import elf from '../../../assets/images/svg/crypto-icons/elf.svg';
import elix from '../../../assets/images/svg/crypto-icons/elix.svg';
import ella from '../../../assets/images/svg/crypto-icons/ella.svg';
import emb from '../../../assets/images/svg/crypto-icons/emb.svg';
import emc from '../../../assets/images/svg/crypto-icons/emc.svg';
import emc2 from '../../../assets/images/svg/crypto-icons/emc2.svg';
import eng from '../../../assets/images/svg/crypto-icons/eng.svg';
import enj from '../../../assets/images/svg/crypto-icons/enj.svg';
import entrp from '../../../assets/images/svg/crypto-icons/entrp.svg';
import eon from '../../../assets/images/svg/crypto-icons/eon.svg';
import eop from '../../../assets/images/svg/crypto-icons/eop.svg';
import eos from '../../../assets/images/svg/crypto-icons/eos.svg';
import eqli from '../../../assets/images/svg/crypto-icons/eqli.svg';
import equa from '../../../assets/images/svg/crypto-icons/equa.svg';
import etc from '../../../assets/images/svg/crypto-icons/etc.svg';
import eth from '../../../assets/images/svg/crypto-icons/eth.svg';
import ethos from '../../../assets/images/svg/crypto-icons/ethos.svg';
import etn from '../../../assets/images/svg/crypto-icons/etn.svg';
import etp from '../../../assets/images/svg/crypto-icons/etp.svg';
import eur from '../../../assets/images/svg/crypto-icons/eur.svg';
import evx from '../../../assets/images/svg/crypto-icons/evx.svg';
import exmo from '../../../assets/images/svg/crypto-icons/exmo.svg';
import exp from '../../../assets/images/svg/crypto-icons/exp.svg';
import fair from '../../../assets/images/svg/crypto-icons/fair.svg';
import fct from '../../../assets/images/svg/crypto-icons/fct.svg';
import fil from '../../../assets/images/svg/crypto-icons/fil.svg';
import fjc from '../../../assets/images/svg/crypto-icons/fjc.svg';
import fldc from '../../../assets/images/svg/crypto-icons/fldc.svg';
import flo from '../../../assets/images/svg/crypto-icons/flo.svg';
import flux from '../../../assets/images/svg/crypto-icons/flux.svg';
import fsn from '../../../assets/images/svg/crypto-icons/fsn.svg';
import ftc from '../../../assets/images/svg/crypto-icons/ftc.svg';
import fuel from '../../../assets/images/svg/crypto-icons/fuel.svg';
import fun from '../../../assets/images/svg/crypto-icons/fun.svg';
import game from '../../../assets/images/svg/crypto-icons/game.svg';
import gas from '../../../assets/images/svg/crypto-icons/gas.svg';
import gbp from '../../../assets/images/svg/crypto-icons/gbp.svg';
import gbx from '../../../assets/images/svg/crypto-icons/gbx.svg';
import gbyte from '../../../assets/images/svg/crypto-icons/gbyte.svg';
import generic from '../../../assets/images/svg/crypto-icons/generic.svg';
import gin from '../../../assets/images/svg/crypto-icons/gin.svg';
import glxt from '../../../assets/images/svg/crypto-icons/glxt.svg';
import gmr from '../../../assets/images/svg/crypto-icons/gmr.svg';
import gno from '../../../assets/images/svg/crypto-icons/gno.svg';
import gnt from '../../../assets/images/svg/crypto-icons/gnt.svg';
import gold from '../../../assets/images/svg/crypto-icons/gold.svg';
import grc from '../../../assets/images/svg/crypto-icons/grc.svg';
import grin from '../../../assets/images/svg/crypto-icons/grin.svg';
import grs from '../../../assets/images/svg/crypto-icons/grs.svg';
import grt from '../../../assets/images/svg/crypto-icons/grt.svg';
import gsc from '../../../assets/images/svg/crypto-icons/gsc.svg';
import gto from '../../../assets/images/svg/crypto-icons/gto.svg';
import gup from '../../../assets/images/svg/crypto-icons/gup.svg';
import gusd from '../../../assets/images/svg/crypto-icons/gusd.svg';
import gvt from '../../../assets/images/svg/crypto-icons/gvt.svg';
import gxs from '../../../assets/images/svg/crypto-icons/gxs.svg';
import gzr from '../../../assets/images/svg/crypto-icons/gzr.svg';
import hight from '../../../assets/images/svg/crypto-icons/hight.svg';
import hns from '../../../assets/images/svg/crypto-icons/hns.svg';
import hodl from '../../../assets/images/svg/crypto-icons/hodl.svg';
import hot from '../../../assets/images/svg/crypto-icons/hot.svg';
import hpb from '../../../assets/images/svg/crypto-icons/hpb.svg';
import hsr from '../../../assets/images/svg/crypto-icons/hsr.svg';
import ht from '../../../assets/images/svg/crypto-icons/ht.svg';
import html from '../../../assets/images/svg/crypto-icons/html.svg';
import huc from '../../../assets/images/svg/crypto-icons/huc.svg';
import husd from '../../../assets/images/svg/crypto-icons/husd.svg';
import hush from '../../../assets/images/svg/crypto-icons/hush.svg';
import icn from '../../../assets/images/svg/crypto-icons/icn.svg';
import icp from '../../../assets/images/svg/crypto-icons/icp.svg';
import icx from '../../../assets/images/svg/crypto-icons/icx.svg';
import ignis from '../../../assets/images/svg/crypto-icons/ignis.svg';
import ilk from '../../../assets/images/svg/crypto-icons/ilk.svg';
import ink from '../../../assets/images/svg/crypto-icons/ink.svg';
import ins from '../../../assets/images/svg/crypto-icons/ins.svg';
import ion from '../../../assets/images/svg/crypto-icons/ion.svg';
import iop from '../../../assets/images/svg/crypto-icons/iop.svg';
import iost from '../../../assets/images/svg/crypto-icons/iost.svg';
import iotx from '../../../assets/images/svg/crypto-icons/iotx.svg';
import iq from '../../../assets/images/svg/crypto-icons/iq.svg';
import itc from '../../../assets/images/svg/crypto-icons/itc.svg';
import jnt from '../../../assets/images/svg/crypto-icons/jnt.svg';
import jpy from '../../../assets/images/svg/crypto-icons/jpy.svg';
import kcs from '../../../assets/images/svg/crypto-icons/kcs.svg';
import kin from '../../../assets/images/svg/crypto-icons/kin.svg';
import klown from '../../../assets/images/svg/crypto-icons/klown.svg';
import kmd from '../../../assets/images/svg/crypto-icons/kmd.svg';
import knc from '../../../assets/images/svg/crypto-icons/knc.svg';
import krb from '../../../assets/images/svg/crypto-icons/krb.svg';
import ksm from '../../../assets/images/svg/crypto-icons/ksm.svg';
import lbc from '../../../assets/images/svg/crypto-icons/lbc.svg';
import lend from '../../../assets/images/svg/crypto-icons/lend.svg';
import leo from '../../../assets/images/svg/crypto-icons/leo.svg';
import link from '../../../assets/images/svg/crypto-icons/link.svg';
import lkk from '../../../assets/images/svg/crypto-icons/lkk.svg';
import loom from '../../../assets/images/svg/crypto-icons/loom.svg';
import lpt from '../../../assets/images/svg/crypto-icons/lpt.svg';
import lrc from '../../../assets/images/svg/crypto-icons/lrc.svg';
import lsk from '../../../assets/images/svg/crypto-icons/lsk.svg';
import ltc from '../../../assets/images/svg/crypto-icons/ltc.svg';
import lun from '../../../assets/images/svg/crypto-icons/lun.svg';
import maid from '../../../assets/images/svg/crypto-icons/maid.svg';
import mana from '../../../assets/images/svg/crypto-icons/mana.svg';
import matic from '../../../assets/images/svg/crypto-icons/matic.svg';
import max from '../../../assets/images/svg/crypto-icons/max.svg';
import mcap from '../../../assets/images/svg/crypto-icons/mcap.svg';
import mco from '../../../assets/images/svg/crypto-icons/mco.svg';
import mda from '../../../assets/images/svg/crypto-icons/mda.svg';
import mds from '../../../assets/images/svg/crypto-icons/mds.svg';
import med from '../../../assets/images/svg/crypto-icons/med.svg';
import meetone from '../../../assets/images/svg/crypto-icons/meetone.svg';
import mft from '../../../assets/images/svg/crypto-icons/mft.svg';
import miota from '../../../assets/images/svg/crypto-icons/miota.svg';
import mith from '../../../assets/images/svg/crypto-icons/mith.svg';
import mkr from '../../../assets/images/svg/crypto-icons/mkr.svg';
import mln from '../../../assets/images/svg/crypto-icons/mln.svg';
import mnx from '../../../assets/images/svg/crypto-icons/mnx.svg';
import mnz from '../../../assets/images/svg/crypto-icons/mnz.svg';
import moac from '../../../assets/images/svg/crypto-icons/moac.svg';
import mod from '../../../assets/images/svg/crypto-icons/mod.svg';
import mona from '../../../assets/images/svg/crypto-icons/mona.svg';
import msr from '../../../assets/images/svg/crypto-icons/msr.svg';
import mth from '../../../assets/images/svg/crypto-icons/mth.svg';
import mtl from '../../../assets/images/svg/crypto-icons/mtl.svg';
import music from '../../../assets/images/svg/crypto-icons/music.svg';
import mzc from '../../../assets/images/svg/crypto-icons/mzc.svg';
import nano from '../../../assets/images/svg/crypto-icons/nano.svg';
import nas from '../../../assets/images/svg/crypto-icons/nas.svg';
import nav from '../../../assets/images/svg/crypto-icons/nav.svg';
import ncash from '../../../assets/images/svg/crypto-icons/ncash.svg';
import ndz from '../../../assets/images/svg/crypto-icons/ndz.svg';
import nebl from '../../../assets/images/svg/crypto-icons/nebl.svg';
import neo from '../../../assets/images/svg/crypto-icons/neo.svg';
import neos from '../../../assets/images/svg/crypto-icons/neos.svg';
import neu from '../../../assets/images/svg/crypto-icons/neu.svg';
import nexo from '../../../assets/images/svg/crypto-icons/nexo.svg';
import ngc from '../../../assets/images/svg/crypto-icons/ngc.svg';
import nio from '../../../assets/images/svg/crypto-icons/nio.svg';
import nkn from '../../../assets/images/svg/crypto-icons/nkn.svg';
import nlc2 from '../../../assets/images/svg/crypto-icons/nlc2.svg';
import nlg from '../../../assets/images/svg/crypto-icons/nlg.svg';
import nmc from '../../../assets/images/svg/crypto-icons/nmc.svg';
import nmr from '../../../assets/images/svg/crypto-icons/nmr.svg';
import npxs from '../../../assets/images/svg/crypto-icons/npxs.svg';
import ntbc from '../../../assets/images/svg/crypto-icons/ntbc.svg';
import nuls from '../../../assets/images/svg/crypto-icons/nuls.svg';
import nxs from '../../../assets/images/svg/crypto-icons/nxs.svg';
import nxt from '../../../assets/images/svg/crypto-icons/nxt.svg';
import oax from '../../../assets/images/svg/crypto-icons/oax.svg';
import ok from '../../../assets/images/svg/crypto-icons/ok.svg';
import omg from '../../../assets/images/svg/crypto-icons/omg.svg';
import omni from '../../../assets/images/svg/crypto-icons/omni.svg';
import one from '../../../assets/images/svg/crypto-icons/one.svg';
import ong from '../../../assets/images/svg/crypto-icons/ong.svg';
import ont from '../../../assets/images/svg/crypto-icons/ont.svg';
import oot from '../../../assets/images/svg/crypto-icons/oot.svg';
import ost from '../../../assets/images/svg/crypto-icons/ost.svg';
import ox from '../../../assets/images/svg/crypto-icons/ox.svg';
import oxt from '../../../assets/images/svg/crypto-icons/oxt.svg';
import part from '../../../assets/images/svg/crypto-icons/part.svg';
import pasc from '../../../assets/images/svg/crypto-icons/pasc.svg';
import pasl from '../../../assets/images/svg/crypto-icons/pasl.svg';
import pax from '../../../assets/images/svg/crypto-icons/pax.svg';
import paxg from '../../../assets/images/svg/crypto-icons/paxg.svg';
import pay from '../../../assets/images/svg/crypto-icons/pay.svg';
import payx from '../../../assets/images/svg/crypto-icons/payx.svg';
import pink from '../../../assets/images/svg/crypto-icons/pink.svg';
import pirl from '../../../assets/images/svg/crypto-icons/pirl.svg';
import pivx from '../../../assets/images/svg/crypto-icons/pivx.svg';
import plr from '../../../assets/images/svg/crypto-icons/plr.svg';
import poa from '../../../assets/images/svg/crypto-icons/poa.svg';
import poe from '../../../assets/images/svg/crypto-icons/poe.svg';
import polis from '../../../assets/images/svg/crypto-icons/polis.svg';
import poly from '../../../assets/images/svg/crypto-icons/poly.svg';
import pot from '../../../assets/images/svg/crypto-icons/pot.svg';
import powr from '../../../assets/images/svg/crypto-icons/powr.svg';
import ppc from '../../../assets/images/svg/crypto-icons/ppc.svg';
import ppp from '../../../assets/images/svg/crypto-icons/ppp.svg';
import ppt from '../../../assets/images/svg/crypto-icons/ppt.svg';
import pre from '../../../assets/images/svg/crypto-icons/pre.svg';
import prl from '../../../assets/images/svg/crypto-icons/prl.svg';
import pungo from '../../../assets/images/svg/crypto-icons/pungo.svg';
import pura from '../../../assets/images/svg/crypto-icons/pura.svg';
import qash from '../../../assets/images/svg/crypto-icons/qash.svg';
import qiwi from '../../../assets/images/svg/crypto-icons/qiwi.svg';
import qlc from '../../../assets/images/svg/crypto-icons/qlc.svg';
import qrl from '../../../assets/images/svg/crypto-icons/qrl.svg';
import qsp from '../../../assets/images/svg/crypto-icons/qsp.svg';
import qtum from '../../../assets/images/svg/crypto-icons/qtum.svg';
import r from '../../../assets/images/svg/crypto-icons/r.svg';
import rads from '../../../assets/images/svg/crypto-icons/rads.svg';
import rap from '../../../assets/images/svg/crypto-icons/rap.svg';
import rcn from '../../../assets/images/svg/crypto-icons/rcn.svg';
import rdd from '../../../assets/images/svg/crypto-icons/rdd.svg';
import rdn from '../../../assets/images/svg/crypto-icons/rdn.svg';
import ren from '../../../assets/images/svg/crypto-icons/ren.svg';
import rep from '../../../assets/images/svg/crypto-icons/rep.svg';
import repv2 from '../../../assets/images/svg/crypto-icons/repv2.svg';
import req from '../../../assets/images/svg/crypto-icons/req.svg';
import rhoc from '../../../assets/images/svg/crypto-icons/rhoc.svg';
import ric from '../../../assets/images/svg/crypto-icons/ric.svg';
import rise from '../../../assets/images/svg/crypto-icons/rise.svg';
import rlc from '../../../assets/images/svg/crypto-icons/rlc.svg';
import rpx from '../../../assets/images/svg/crypto-icons/rpx.svg';
import rub from '../../../assets/images/svg/crypto-icons/rub.svg';
import rvn from '../../../assets/images/svg/crypto-icons/rvn.svg';
import ryo from '../../../assets/images/svg/crypto-icons/ryo.svg';
import safe from '../../../assets/images/svg/crypto-icons/safe.svg';
import safemoon from '../../../assets/images/svg/crypto-icons/safemoon.svg';
import sai from '../../../assets/images/svg/crypto-icons/sai.svg';
import salt from '../../../assets/images/svg/crypto-icons/salt.svg';
import san from '../../../assets/images/svg/crypto-icons/san.svg';
import sand from '../../../assets/images/svg/crypto-icons/sand.svg';
import sbd from '../../../assets/images/svg/crypto-icons/sbd.svg';
import sberbank from '../../../assets/images/svg/crypto-icons/sberbank.svg';
import sc from '../../../assets/images/svg/crypto-icons/sc.svg';
import shift from '../../../assets/images/svg/crypto-icons/shift.svg';
import sib from '../../../assets/images/svg/crypto-icons/sib.svg';
import sin from '../../../assets/images/svg/crypto-icons/sin.svg';
import skl from '../../../assets/images/svg/crypto-icons/skl.svg';
import sky from '../../../assets/images/svg/crypto-icons/sky.svg';
import slr from '../../../assets/images/svg/crypto-icons/slr.svg';
import sls from '../../../assets/images/svg/crypto-icons/sls.svg';
import smart from '../../../assets/images/svg/crypto-icons/smart.svg';
import sngls from '../../../assets/images/svg/crypto-icons/sngls.svg';
import snm from '../../../assets/images/svg/crypto-icons/snm.svg';
import snt from '../../../assets/images/svg/crypto-icons/snt.svg';
import snx from '../../../assets/images/svg/crypto-icons/snx.svg';
import soc from '../../../assets/images/svg/crypto-icons/soc.svg';
import sol from '../../../assets/images/svg/crypto-icons/sol.svg';
import spacehbit from '../../../assets/images/svg/crypto-icons/spacehbit.svg';
import spank from '../../../assets/images/svg/crypto-icons/spank.svg';
import sphtx from '../../../assets/images/svg/crypto-icons/sphtx.svg';
import srn from '../../../assets/images/svg/crypto-icons/srn.svg';
import stak from '../../../assets/images/svg/crypto-icons/stak.svg';
import start from '../../../assets/images/svg/crypto-icons/start.svg';
import steem from '../../../assets/images/svg/crypto-icons/steem.svg';
import storj from '../../../assets/images/svg/crypto-icons/storj.svg';
import storm from '../../../assets/images/svg/crypto-icons/storm.svg';
import stox from '../../../assets/images/svg/crypto-icons/stox.svg';
import stq from '../../../assets/images/svg/crypto-icons/stq.svg';
import strat from '../../../assets/images/svg/crypto-icons/strat.svg';
import stx from '../../../assets/images/svg/crypto-icons/stx.svg';
import sub from '../../../assets/images/svg/crypto-icons/sub.svg';
import sumo from '../../../assets/images/svg/crypto-icons/sumo.svg';
import sushi from '../../../assets/images/svg/crypto-icons/sushi.svg';
import sys from '../../../assets/images/svg/crypto-icons/sys.svg';
import taas from '../../../assets/images/svg/crypto-icons/taas.svg';
import tau from '../../../assets/images/svg/crypto-icons/tau.svg';
import tbx from '../../../assets/images/svg/crypto-icons/tbx.svg';
import tel from '../../../assets/images/svg/crypto-icons/tel.svg';
import ten from '../../../assets/images/svg/crypto-icons/ten.svg';
import tern from '../../../assets/images/svg/crypto-icons/tern.svg';
import tgch from '../../../assets/images/svg/crypto-icons/tgch.svg';
import theta from '../../../assets/images/svg/crypto-icons/theta.svg';
import tix from '../../../assets/images/svg/crypto-icons/tix.svg';
import tkn from '../../../assets/images/svg/crypto-icons/tkn.svg';
import tks from '../../../assets/images/svg/crypto-icons/tks.svg';
import tnb from '../../../assets/images/svg/crypto-icons/tnb.svg';
import tnc from '../../../assets/images/svg/crypto-icons/tnc.svg';
import tnt from '../../../assets/images/svg/crypto-icons/tnt.svg';
import tomo from '../../../assets/images/svg/crypto-icons/tomo.svg';
import tpay from '../../../assets/images/svg/crypto-icons/tpay.svg';
import trig from '../../../assets/images/svg/crypto-icons/trig.svg';
import trtl from '../../../assets/images/svg/crypto-icons/trtl.svg';
import trx from '../../../assets/images/svg/crypto-icons/trx.svg';
import tusd from '../../../assets/images/svg/crypto-icons/tusd.svg';
import tzc from '../../../assets/images/svg/crypto-icons/tzc.svg';
import ubq from '../../../assets/images/svg/crypto-icons/ubq.svg';
import uma from '../../../assets/images/svg/crypto-icons/uma.svg';
import uni from '../../../assets/images/svg/crypto-icons/uni.svg';
import unity from '../../../assets/images/svg/crypto-icons/unity.svg';
import usd from '../../../assets/images/svg/crypto-icons/usd.svg';
import usdc from '../../../assets/images/svg/crypto-icons/usdc.svg';
import usdt from '../../../assets/images/svg/crypto-icons/usdt.svg';
import utk from '../../../assets/images/svg/crypto-icons/utk.svg';
import veri from '../../../assets/images/svg/crypto-icons/veri.svg';
import vet from '../../../assets/images/svg/crypto-icons/vet.svg';
import via from '../../../assets/images/svg/crypto-icons/via.svg';
import vib from '../../../assets/images/svg/crypto-icons/vib.svg';
import vibe from '../../../assets/images/svg/crypto-icons/vibe.svg';
import vivo from '../../../assets/images/svg/crypto-icons/vivo.svg';
import vrc from '../../../assets/images/svg/crypto-icons/vrc.svg';
import vrsc from '../../../assets/images/svg/crypto-icons/vrsc.svg';
import vtc from '../../../assets/images/svg/crypto-icons/vtc.svg';
import vtho from '../../../assets/images/svg/crypto-icons/vtho.svg';
import wabi from '../../../assets/images/svg/crypto-icons/wabi.svg';
import wan from '../../../assets/images/svg/crypto-icons/wan.svg';
import waves from '../../../assets/images/svg/crypto-icons/waves.svg';
import wax from '../../../assets/images/svg/crypto-icons/wax.svg';
import wbtc from '../../../assets/images/svg/crypto-icons/wbtc.svg';
import wgr from '../../../assets/images/svg/crypto-icons/wgr.svg';
import wicc from '../../../assets/images/svg/crypto-icons/wicc.svg';
import wings from '../../../assets/images/svg/crypto-icons/wings.svg';
import wpr from '../../../assets/images/svg/crypto-icons/wpr.svg';
import wtc from '../../../assets/images/svg/crypto-icons/wtc.svg';
import x from '../../../assets/images/svg/crypto-icons/x.svg';
import xas from '../../../assets/images/svg/crypto-icons/xas.svg';
import xbc from '../../../assets/images/svg/crypto-icons/xbc.svg';
import xbp from '../../../assets/images/svg/crypto-icons/xbp.svg';
import xby from '../../../assets/images/svg/crypto-icons/xby.svg';
import xcp from '../../../assets/images/svg/crypto-icons/xcp.svg';
import xdn from '../../../assets/images/svg/crypto-icons/xdn.svg';
import xem from '../../../assets/images/svg/crypto-icons/xem.svg';
import xin from '../../../assets/images/svg/crypto-icons/xin.svg';
import xlm from '../../../assets/images/svg/crypto-icons/xlm.svg';
import xmcc from '../../../assets/images/svg/crypto-icons/xmcc.svg';
import xmg from '../../../assets/images/svg/crypto-icons/xmg.svg';
import xmo from '../../../assets/images/svg/crypto-icons/xmo.svg';
import xmr from '../../../assets/images/svg/crypto-icons/xmr.svg';
import xmy from '../../../assets/images/svg/crypto-icons/xmy.svg';
import xp from '../../../assets/images/svg/crypto-icons/xp.svg';
import xpa from '../../../assets/images/svg/crypto-icons/xpa.svg';
import xpm from '../../../assets/images/svg/crypto-icons/xpm.svg';
import xpr from '../../../assets/images/svg/crypto-icons/xpr.svg';
import xrp from '../../../assets/images/svg/crypto-icons/xrp.svg';
import xsg from '../../../assets/images/svg/crypto-icons/xsg.svg';
import xtz from '../../../assets/images/svg/crypto-icons/xtz.svg';
import xuc from '../../../assets/images/svg/crypto-icons/xuc.svg';
import xvc from '../../../assets/images/svg/crypto-icons/xvc.svg';
import xvg from '../../../assets/images/svg/crypto-icons/xvg.svg';
import xzc from '../../../assets/images/svg/crypto-icons/xzc.svg';
import yfi from '../../../assets/images/svg/crypto-icons/yfi.svg';
import yoyow from '../../../assets/images/svg/crypto-icons/yoyow.svg';
import zcl from '../../../assets/images/svg/crypto-icons/zcl.svg';
import zec from '../../../assets/images/svg/crypto-icons/zec.svg';
import zel from '../../../assets/images/svg/crypto-icons/zel.svg';
import zen from '../../../assets/images/svg/crypto-icons/zen.svg';
import zest from '../../../assets/images/svg/crypto-icons/zest.svg';
import zil from '../../../assets/images/svg/crypto-icons/zil.svg';
import zilla from '../../../assets/images/svg/crypto-icons/zilla.svg';
import zrx from '../../../assets/images/svg/crypto-icons/zrx.svg';

const CryptoIcons = () => {
  document.title = 'Crypto Icons | Velzon - React Admin & Dashboard Template';
  return (
    <React.Fragment>
      <div className='page-content'>
        <Container fluid>
          <BreadCrumb title='Crypto Icons' pageTitle='Icons' />
          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader>
                  <h5 className='card-title mb-1'>Examples</h5>
                  <p className='text-muted mb-0'>
                    Use{' '}
                    <code>
                      &lt;img src=" assets/images/svg/crypto-icons/**.svg"&gt;
                    </code>{' '}
                    class.
                  </p>
                </CardHeader>
                <CardBody>
                  <Row className='icon-demo-content'>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={pac} alt='' className='avatar-xxs' />
                        $pac
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={c0xbtc} alt='' className='avatar-xxs' /> 0xbtc
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={c2give} alt='' className='avatar-xxs' /> 2give
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={aave} alt='' className='avatar-xxs' /> aave
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={abt} alt='' className='avatar-xxs' /> abt
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={act} alt='' className='avatar-xxs' /> act
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={actn} alt='' className='avatar-xxs' /> actn
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={ada} alt='' className='avatar-xxs' /> ada
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={add} alt='' className='avatar-xxs' /> add
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={adx} alt='' className='avatar-xxs' /> adx
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={ae} alt='' className='avatar-xxs' /> ae
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={aeon} alt='' className='avatar-xxs' /> aeon
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={aeur} alt='' className='avatar-xxs' /> aeur
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={agi} alt='' className='avatar-xxs' /> agi
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={agrs} alt='' className='avatar-xxs' /> agrs
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={aion} alt='' className='avatar-xxs' /> aion
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={algo} alt='' className='avatar-xxs' /> algo
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={amb} alt='' className='avatar-xxs' /> amb
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={amp} alt='' className='avatar-xxs' /> amp
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={ampl} alt='' className='avatar-xxs' /> ampl
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={ankr} alt='' className='avatar-xxs' /> ankr
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={ant} alt='' className='avatar-xxs' /> ant
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={apex} alt='' className='avatar-xxs' /> apex
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={appc} alt='' className='avatar-xxs' /> appc
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={ardr} alt='' className='avatar-xxs' /> ardr
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={arg} alt='' className='avatar-xxs' /> arg
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={ark} alt='' className='avatar-xxs' /> ark
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={arn} alt='' className='avatar-xxs' /> arn
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={arnx} alt='' className='avatar-xxs' /> arnx
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={ary} alt='' className='avatar-xxs' /> ary
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={ast} alt='' className='avatar-xxs' /> ast
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={atm} alt='' className='avatar-xxs' /> atm
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={atom} alt='' className='avatar-xxs' /> atom
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={audr} alt='' className='avatar-xxs' /> audr
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={auto} alt='' className='avatar-xxs' /> auto
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={aywa} alt='' className='avatar-xxs' /> aywa
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={bab} alt='' className='avatar-xxs' /> bab
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={bal} alt='' className='avatar-xxs' /> bal
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={band} alt='' className='avatar-xxs' /> band
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={bat} alt='' className='avatar-xxs' /> bat
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={bay} alt='' className='avatar-xxs' /> bay
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={bcbc} alt='' className='avatar-xxs' /> bcbc
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={bcc} alt='' className='avatar-xxs' /> bcc
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={bcd} alt='' className='avatar-xxs' /> bcd
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={bch} alt='' className='avatar-xxs' /> bch
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={bcio} alt='' className='avatar-xxs' /> bcio
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={bcn} alt='' className='avatar-xxs' /> bcn
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={bco} alt='' className='avatar-xxs' /> bco
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={bcpt} alt='' className='avatar-xxs' /> bcpt
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={bdl} alt='' className='avatar-xxs' /> bdl
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={beam} alt='' className='avatar-xxs' /> beam
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={bela} alt='' className='avatar-xxs' /> bela
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={bix} alt='' className='avatar-xxs' /> bix
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={blcn} alt='' className='avatar-xxs' /> blcn
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={blk} alt='' className='avatar-xxs' /> blk
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={block} alt='' className='avatar-xxs' /> block
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={blz} alt='' className='avatar-xxs' /> blz
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={bnb} alt='' className='avatar-xxs' /> bnb
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={bnt} alt='' className='avatar-xxs' /> bnt
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={bnty} alt='' className='avatar-xxs' /> bnty
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={booty} alt='' className='avatar-xxs' /> booty
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={bos} alt='' className='avatar-xxs' /> bos
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={bpt} alt='' className='avatar-xxs' /> bpt
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={bq} alt='' className='avatar-xxs' /> bq
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={brd} alt='' className='avatar-xxs' /> brd
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={bsd} alt='' className='avatar-xxs' /> bsd
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={bsv} alt='' className='avatar-xxs' /> bsv
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={btc} alt='' className='avatar-xxs' /> btc
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={btcd} alt='' className='avatar-xxs' /> btcd
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={btch} alt='' className='avatar-xxs' /> btch
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={btcp} alt='' className='avatar-xxs' /> btcp
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={btcz} alt='' className='avatar-xxs' /> btcz
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={btdx} alt='' className='avatar-xxs' /> btdx
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={btg} alt='' className='avatar-xxs' /> btg
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={btm} alt='' className='avatar-xxs' /> btm
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={bts} alt='' className='avatar-xxs' /> bts
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={btt} alt='' className='avatar-xxs' /> btt
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={btx} alt='' className='avatar-xxs' /> btx
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={burst} alt='' className='avatar-xxs' /> burst
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={bze} alt='' className='avatar-xxs' /> bze
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={call} alt='' className='avatar-xxs' /> call
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={cc} alt='' className='avatar-xxs' /> cc
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={cdn} alt='' className='avatar-xxs' /> cdn
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={cdt} alt='' className='avatar-xxs' /> cdt
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={cenz} alt='' className='avatar-xxs' /> cenz
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={chain} alt='' className='avatar-xxs' /> chain
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={chat} alt='' className='avatar-xxs' /> chat
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={chips} alt='' className='avatar-xxs' /> chips
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={chsb} alt='' className='avatar-xxs' /> chsb
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={cix} alt='' className='avatar-xxs' /> cix
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={clam} alt='' className='avatar-xxs' /> clam
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={cloak} alt='' className='avatar-xxs' /> cloak
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={cmm} alt='' className='avatar-xxs' /> cmm
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={cmt} alt='' className='avatar-xxs' /> cmt
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={cnd} alt='' className='avatar-xxs' /> cnd
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={cnx} alt='' className='avatar-xxs' /> cnx
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={cny} alt='' className='avatar-xxs' /> cny
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={cob} alt='' className='avatar-xxs' /> cob
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={colx} alt='' className='avatar-xxs' /> colx
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={comp} alt='' className='avatar-xxs' /> comp
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={coqui} alt='' className='avatar-xxs' /> coqui
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={cred} alt='' className='avatar-xxs' /> cred
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={crpt} alt='' className='avatar-xxs' /> crpt
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={crv} alt='' className='avatar-xxs' /> crv
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={crw} alt='' className='avatar-xxs' /> crw
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={cs} alt='' className='avatar-xxs' /> cs
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={ctr} alt='' className='avatar-xxs' /> ctr
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={ctxc} alt='' className='avatar-xxs' /> ctxc
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={cvc} alt='' className='avatar-xxs' /> cvc
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={d} alt='' className='avatar-xxs' /> d
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={dai} alt='' className='avatar-xxs' /> dai
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={dash} alt='' className='avatar-xxs' /> dash
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={dat} alt='' className='avatar-xxs' /> dat
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={data} alt='' className='avatar-xxs' /> data
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={dbc} alt='' className='avatar-xxs' /> dbc
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={dcn} alt='' className='avatar-xxs' /> dcn
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={dcr} alt='' className='avatar-xxs' /> dcr
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={deez} alt='' className='avatar-xxs' /> deez
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={dent} alt='' className='avatar-xxs' /> dent
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={dew} alt='' className='avatar-xxs' /> dew
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={dgb} alt='' className='avatar-xxs' /> dgb
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={dgd} alt='' className='avatar-xxs' /> dgd
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={dlt} alt='' className='avatar-xxs' /> dlt
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={dnt} alt='' className='avatar-xxs' /> dnt
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={dock} alt='' className='avatar-xxs' /> dock
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={doge} alt='' className='avatar-xxs' /> doge
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={dot} alt='' className='avatar-xxs' /> dot
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={drgn} alt='' className='avatar-xxs' /> drgn
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={drop} alt='' className='avatar-xxs' /> drop
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={dta} alt='' className='avatar-xxs' /> dta
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={dth} alt='' className='avatar-xxs' /> dth
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={dtr} alt='' className='avatar-xxs' /> dtr
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={ebst} alt='' className='avatar-xxs' /> ebst
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={eca} alt='' className='avatar-xxs' /> eca
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={edg} alt='' className='avatar-xxs' /> edg
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={edo} alt='' className='avatar-xxs' /> edo
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={edoge} alt='' className='avatar-xxs' /> edoge
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={ela} alt='' className='avatar-xxs' /> ela
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={elec} alt='' className='avatar-xxs' /> elec
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={elf} alt='' className='avatar-xxs' /> elf
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={elix} alt='' className='avatar-xxs' /> elix
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={ella} alt='' className='avatar-xxs' /> ella
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={emb} alt='' className='avatar-xxs' /> emb
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={emc} alt='' className='avatar-xxs' /> emc
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={emc2} alt='' className='avatar-xxs' /> emc2
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={eng} alt='' className='avatar-xxs' /> eng
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={enj} alt='' className='avatar-xxs' /> enj
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={entrp} alt='' className='avatar-xxs' /> entrp
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={eon} alt='' className='avatar-xxs' /> eon
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={eop} alt='' className='avatar-xxs' /> eop
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={eos} alt='' className='avatar-xxs' /> eos
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={eqli} alt='' className='avatar-xxs' /> eqli
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={equa} alt='' className='avatar-xxs' /> equa
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={etc} alt='' className='avatar-xxs' /> etc
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={eth} alt='' className='avatar-xxs' /> eth
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={ethos} alt='' className='avatar-xxs' /> ethos
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={etn} alt='' className='avatar-xxs' /> etn
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={etp} alt='' className='avatar-xxs' /> etp
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={eur} alt='' className='avatar-xxs' /> eur
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={evx} alt='' className='avatar-xxs' /> evx
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={exmo} alt='' className='avatar-xxs' /> exmo
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={exp} alt='' className='avatar-xxs' /> exp
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={fair} alt='' className='avatar-xxs' /> fair
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={fct} alt='' className='avatar-xxs' /> fct
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={fil} alt='' className='avatar-xxs' /> fil
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={fjc} alt='' className='avatar-xxs' /> fjc
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={fldc} alt='' className='avatar-xxs' /> fldc
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={flo} alt='' className='avatar-xxs' /> flo
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={flux} alt='' className='avatar-xxs' /> flux
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={fsn} alt='' className='avatar-xxs' /> fsn
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={ftc} alt='' className='avatar-xxs' /> ftc
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={fuel} alt='' className='avatar-xxs' /> fuel
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={fun} alt='' className='avatar-xxs' /> fun
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={game} alt='' className='avatar-xxs' /> game
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={gas} alt='' className='avatar-xxs' /> gas
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={gbp} alt='' className='avatar-xxs' /> gbp
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={gbx} alt='' className='avatar-xxs' /> gbx
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={gbyte} alt='' className='avatar-xxs' /> gbyte
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={generic} alt='' className='avatar-xxs' />{' '}
                        generic
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={gin} alt='' className='avatar-xxs' /> gin
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={glxt} alt='' className='avatar-xxs' /> glxt
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={gmr} alt='' className='avatar-xxs' /> gmr
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={gno} alt='' className='avatar-xxs' /> gno
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={gnt} alt='' className='avatar-xxs' /> gnt
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={gold} alt='' className='avatar-xxs' /> gold
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={grc} alt='' className='avatar-xxs' /> grc
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={grin} alt='' className='avatar-xxs' /> grin
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={grs} alt='' className='avatar-xxs' /> grs
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={grt} alt='' className='avatar-xxs' /> grt
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={gsc} alt='' className='avatar-xxs' /> gsc
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={gto} alt='' className='avatar-xxs' /> gto
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={gup} alt='' className='avatar-xxs' /> gup
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={gusd} alt='' className='avatar-xxs' /> gusd
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={gvt} alt='' className='avatar-xxs' /> gvt
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={gxs} alt='' className='avatar-xxs' /> gxs
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={gzr} alt='' className='avatar-xxs' /> gzr
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={hight} alt='' className='avatar-xxs' /> hight
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={hns} alt='' className='avatar-xxs' /> hns
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={hodl} alt='' className='avatar-xxs' /> hodl
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={hot} alt='' className='avatar-xxs' /> hot
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={hpb} alt='' className='avatar-xxs' /> hpb
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={hsr} alt='' className='avatar-xxs' /> hsr
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={ht} alt='' className='avatar-xxs' /> ht
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={html} alt='' className='avatar-xxs' /> html
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={huc} alt='' className='avatar-xxs' /> huc
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={husd} alt='' className='avatar-xxs' /> husd
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={hush} alt='' className='avatar-xxs' /> hush
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={icn} alt='' className='avatar-xxs' /> icn
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={icp} alt='' className='avatar-xxs' /> icp
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={icx} alt='' className='avatar-xxs' /> icx
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={ignis} alt='' className='avatar-xxs' /> ignis
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={ilk} alt='' className='avatar-xxs' /> ilk
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={ink} alt='' className='avatar-xxs' /> ink
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={ins} alt='' className='avatar-xxs' /> ins
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={ion} alt='' className='avatar-xxs' /> ion
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={iop} alt='' className='avatar-xxs' /> iop
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={iop} alt='' className='avatar-xxs' /> iop
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={iost} alt='' className='avatar-xxs' /> iost
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={iotx} alt='' className='avatar-xxs' /> iotx
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={iq} alt='' className='avatar-xxs' /> iq
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={itc} alt='' className='avatar-xxs' /> itc
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={jnt} alt='' className='avatar-xxs' /> jnt
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={jpy} alt='' className='avatar-xxs' /> jpy
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={kcs} alt='' className='avatar-xxs' /> kcs
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={kin} alt='' className='avatar-xxs' /> kin
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={klown} alt='' className='avatar-xxs' /> klown
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={kmd} alt='' className='avatar-xxs' /> kmd
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={knc} alt='' className='avatar-xxs' /> knc
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={krb} alt='' className='avatar-xxs' /> krb
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={ksm} alt='' className='avatar-xxs' /> ksm
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={lbc} alt='' className='avatar-xxs' /> lbc
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={lend} alt='' className='avatar-xxs' /> lend
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={leo} alt='' className='avatar-xxs' /> leo
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={link} alt='' className='avatar-xxs' /> link
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={lkk} alt='' className='avatar-xxs' /> lkk
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={loom} alt='' className='avatar-xxs' /> loom
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={lpt} alt='' className='avatar-xxs' /> lpt
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={lrc} alt='' className='avatar-xxs' /> lrc
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={lsk} alt='' className='avatar-xxs' /> lsk
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={ltc} alt='' className='avatar-xxs' /> ltc
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={lun} alt='' className='avatar-xxs' /> lun
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={maid} alt='' className='avatar-xxs' /> maid
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={mana} alt='' className='avatar-xxs' /> mana
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={matic} alt='' className='avatar-xxs' /> matic
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={max} alt='' className='avatar-xxs' /> max
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={mcap} alt='' className='avatar-xxs' /> mcap
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={mco} alt='' className='avatar-xxs' /> mco
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={mda} alt='' className='avatar-xxs' /> mda
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={mds} alt='' className='avatar-xxs' /> mds
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={med} alt='' className='avatar-xxs' /> med
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={meetone} alt='' className='avatar-xxs' />{' '}
                        meetone
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={mft} alt='' className='avatar-xxs' /> mft
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={miota} alt='' className='avatar-xxs' /> miota
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={mith} alt='' className='avatar-xxs' /> mith
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={mkr} alt='' className='avatar-xxs' /> mkr
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={mln} alt='' className='avatar-xxs' /> mln
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={mnx} alt='' className='avatar-xxs' /> mnx
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={mnz} alt='' className='avatar-xxs' /> mnz
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={moac} alt='' className='avatar-xxs' /> moac
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={mod} alt='' className='avatar-xxs' /> mod
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={mona} alt='' className='avatar-xxs' /> mona
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={msr} alt='' className='avatar-xxs' /> msr
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={mth} alt='' className='avatar-xxs' /> mth
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={mtl} alt='' className='avatar-xxs' /> mtl
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={music} alt='' className='avatar-xxs' /> music
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={mzc} alt='' className='avatar-xxs' /> mzc
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={nano} alt='' className='avatar-xxs' /> nano
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={nas} alt='' className='avatar-xxs' /> nas
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={nav} alt='' className='avatar-xxs' /> nav
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={ncash} alt='' className='avatar-xxs' /> ncash
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={ndz} alt='' className='avatar-xxs' /> ndz
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={nebl} alt='' className='avatar-xxs' /> nebl
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={neo} alt='' className='avatar-xxs' /> neo
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={neos} alt='' className='avatar-xxs' /> neos
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={neu} alt='' className='avatar-xxs' /> neu
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={nexo} alt='' className='avatar-xxs' /> nexo
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={ngc} alt='' className='avatar-xxs' /> ngc
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={nio} alt='' className='avatar-xxs' /> nio
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={nkn} alt='' className='avatar-xxs' /> nkn
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={nlc2} alt='' className='avatar-xxs' /> nlc2
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={nlg} alt='' className='avatar-xxs' /> nlg
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={nmc} alt='' className='avatar-xxs' /> nmc
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={nmr} alt='' className='avatar-xxs' /> nmr
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={npxs} alt='' className='avatar-xxs' /> npxs
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={ntbc} alt='' className='avatar-xxs' /> ntbc
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={nuls} alt='' className='avatar-xxs' /> nuls
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={nxs} alt='' className='avatar-xxs' /> nxs
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={nxt} alt='' className='avatar-xxs' /> nxt
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={oax} alt='' className='avatar-xxs' /> oax
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={ok} alt='' className='avatar-xxs' /> ok
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={omg} alt='' className='avatar-xxs' /> omg
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={omni} alt='' className='avatar-xxs' /> omni
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={one} alt='' className='avatar-xxs' /> one
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={ong} alt='' className='avatar-xxs' /> ong
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={ont} alt='' className='avatar-xxs' /> ont
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={oot} alt='' className='avatar-xxs' /> oot
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={ost} alt='' className='avatar-xxs' /> ost
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={ox} alt='' className='avatar-xxs' /> ox
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={oxt} alt='' className='avatar-xxs' /> oxt
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={part} alt='' className='avatar-xxs' /> part
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={pasc} alt='' className='avatar-xxs' /> pasc
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={pasl} alt='' className='avatar-xxs' /> pasl
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={pax} alt='' className='avatar-xxs' /> pax
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={paxg} alt='' className='avatar-xxs' /> paxg
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={pay} alt='' className='avatar-xxs' /> pay
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={payx} alt='' className='avatar-xxs' /> payx
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={pink} alt='' className='avatar-xxs' /> pink
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={pirl} alt='' className='avatar-xxs' /> pirl
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={pivx} alt='' className='avatar-xxs' /> pivx
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={plr} alt='' className='avatar-xxs' /> plr
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={poa} alt='' className='avatar-xxs' /> poa
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={poe} alt='' className='avatar-xxs' /> poe
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={polis} alt='' className='avatar-xxs' /> polis
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={poly} alt='' className='avatar-xxs' /> poly
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={pot} alt='' className='avatar-xxs' /> pot
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={powr} alt='' className='avatar-xxs' /> powr
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={ppc} alt='' className='avatar-xxs' /> ppc
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={ppp} alt='' className='avatar-xxs' /> ppp
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={ppt} alt='' className='avatar-xxs' /> ppt
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={pre} alt='' className='avatar-xxs' /> pre
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={prl} alt='' className='avatar-xxs' /> prl
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={pungo} alt='' className='avatar-xxs' /> pungo
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={pura} alt='' className='avatar-xxs' /> pura
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={qash} alt='' className='avatar-xxs' /> qash
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={qiwi} alt='' className='avatar-xxs' /> qiwi
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={qlc} alt='' className='avatar-xxs' /> qlc
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={qrl} alt='' className='avatar-xxs' /> qrl
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={qsp} alt='' className='avatar-xxs' /> qsp
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={qtum} alt='' className='avatar-xxs' /> qtum
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={r} alt='' className='avatar-xxs' /> r
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={rads} alt='' className='avatar-xxs' /> rads
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={rap} alt='' className='avatar-xxs' /> rap
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={rcn} alt='' className='avatar-xxs' /> rcn
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={rdd} alt='' className='avatar-xxs' /> rdd
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={rdn} alt='' className='avatar-xxs' /> rdn
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={ren} alt='' className='avatar-xxs' /> ren
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={rep} alt='' className='avatar-xxs' /> rep
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={repv2} alt='' className='avatar-xxs' /> repv2
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={req} alt='' className='avatar-xxs' /> req
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={rhoc} alt='' className='avatar-xxs' /> rhoc
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={ric} alt='' className='avatar-xxs' /> ric
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={rise} alt='' className='avatar-xxs' /> rise
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={rlc} alt='' className='avatar-xxs' /> rlc
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={rpx} alt='' className='avatar-xxs' /> rpx
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={rub} alt='' className='avatar-xxs' /> rub
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={rvn} alt='' className='avatar-xxs' /> rvn
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={ryo} alt='' className='avatar-xxs' /> ryo
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={safe} alt='' className='avatar-xxs' /> safe
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={safemoon} alt='' className='avatar-xxs' />{' '}
                        safemoon
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={sai} alt='' className='avatar-xxs' /> sai
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={salt} alt='' className='avatar-xxs' /> salt
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={san} alt='' className='avatar-xxs' /> san
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={sand} alt='' className='avatar-xxs' /> sand
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={sbd} alt='' className='avatar-xxs' /> sbd
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={sberbank} alt='' className='avatar-xxs' />{' '}
                        sberbank
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={sc} alt='' className='avatar-xxs' /> sc
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={shift} alt='' className='avatar-xxs' /> shift
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={sib} alt='' className='avatar-xxs' /> sib
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={sin} alt='' className='avatar-xxs' /> sin
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={skl} alt='' className='avatar-xxs' /> skl
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={sky} alt='' className='avatar-xxs' /> sky
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={slr} alt='' className='avatar-xxs' /> slr
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={sls} alt='' className='avatar-xxs' /> sls
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={smart} alt='' className='avatar-xxs' /> smart
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={sngls} alt='' className='avatar-xxs' /> sngls
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={snm} alt='' className='avatar-xxs' /> snm
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={snt} alt='' className='avatar-xxs' /> snt
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={snx} alt='' className='avatar-xxs' /> snx
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={soc} alt='' className='avatar-xxs' /> soc
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={sol} alt='' className='avatar-xxs' /> sol
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={spacehbit} alt='' className='avatar-xxs' />{' '}
                        spacehbit
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={spank} alt='' className='avatar-xxs' /> spank
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={sphtx} alt='' className='avatar-xxs' /> sphtx
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={srn} alt='' className='avatar-xxs' /> srn
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={stak} alt='' className='avatar-xxs' /> stak
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={start} alt='' className='avatar-xxs' /> start
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={steem} alt='' className='avatar-xxs' /> steem
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={storj} alt='' className='avatar-xxs' /> storj
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={storm} alt='' className='avatar-xxs' /> storm
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={stox} alt='' className='avatar-xxs' /> stox
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={stq} alt='' className='avatar-xxs' /> stq
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={strat} alt='' className='avatar-xxs' /> strat
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={stx} alt='' className='avatar-xxs' /> stx
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={sub} alt='' className='avatar-xxs' /> sub
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={sumo} alt='' className='avatar-xxs' /> sumo
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={sushi} alt='' className='avatar-xxs' /> sushi
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={sys} alt='' className='avatar-xxs' /> sys
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={taas} alt='' className='avatar-xxs' /> taas
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={tau} alt='' className='avatar-xxs' /> tau
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={tbx} alt='' className='avatar-xxs' /> tbx
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={tel} alt='' className='avatar-xxs' /> tel
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={ten} alt='' className='avatar-xxs' /> ten
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={tern} alt='' className='avatar-xxs' /> tern
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={tgch} alt='' className='avatar-xxs' /> tgch
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={theta} alt='' className='avatar-xxs' /> theta
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={tix} alt='' className='avatar-xxs' /> tix
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={tkn} alt='' className='avatar-xxs' /> tkn
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={tks} alt='' className='avatar-xxs' /> tks
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={tnb} alt='' className='avatar-xxs' /> tnb
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={tnc} alt='' className='avatar-xxs' /> tnc
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={tnt} alt='' className='avatar-xxs' /> tnt
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={tomo} alt='' className='avatar-xxs' /> tomo
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={tpay} alt='' className='avatar-xxs' /> tpay
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={trig} alt='' className='avatar-xxs' /> trig
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={trtl} alt='' className='avatar-xxs' /> trtl
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={trx} alt='' className='avatar-xxs' /> trx
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={tusd} alt='' className='avatar-xxs' /> tusd
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={tzc} alt='' className='avatar-xxs' /> tzc
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={ubq} alt='' className='avatar-xxs' /> ubq
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={uma} alt='' className='avatar-xxs' /> uma
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={uni} alt='' className='avatar-xxs' /> uni
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={unity} alt='' className='avatar-xxs' /> unity
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={usd} alt='' className='avatar-xxs' /> usd
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={usdc} alt='' className='avatar-xxs' /> usdc
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={usdt} alt='' className='avatar-xxs' /> usdt
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={utk} alt='' className='avatar-xxs' /> utk
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={veri} alt='' className='avatar-xxs' /> veri
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={vet} alt='' className='avatar-xxs' /> vet
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={via} alt='' className='avatar-xxs' /> via
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={vib} alt='' className='avatar-xxs' /> vib
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={vibe} alt='' className='avatar-xxs' /> vibe
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={vivo} alt='' className='avatar-xxs' /> vivo
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={vrc} alt='' className='avatar-xxs' /> vrc
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={vrsc} alt='' className='avatar-xxs' /> vrsc
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={vtc} alt='' className='avatar-xxs' /> vtc
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={vtho} alt='' className='avatar-xxs' /> vtho
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={wabi} alt='' className='avatar-xxs' /> wabi
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={wan} alt='' className='avatar-xxs' /> wan
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={waves} alt='' className='avatar-xxs' /> waves
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={wax} alt='' className='avatar-xxs' /> wax
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={wbtc} alt='' className='avatar-xxs' /> wbtc
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={wgr} alt='' className='avatar-xxs' /> wgr
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={wicc} alt='' className='avatar-xxs' /> wicc
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={wings} alt='' className='avatar-xxs' /> wings
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={wpr} alt='' className='avatar-xxs' /> wpr
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={wtc} alt='' className='avatar-xxs' /> wtc
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={x} alt='' className='avatar-xxs' /> x
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={xas} alt='' className='avatar-xxs' /> xas
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={xbc} alt='' className='avatar-xxs' /> xbc
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={xbp} alt='' className='avatar-xxs' /> xbp
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={xby} alt='' className='avatar-xxs' /> xby
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={xcp} alt='' className='avatar-xxs' /> xcp
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={xdn} alt='' className='avatar-xxs' /> xdn
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={xem} alt='' className='avatar-xxs' /> xem
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={xin} alt='' className='avatar-xxs' /> xin
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={xlm} alt='' className='avatar-xxs' /> xlm
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={xmcc} alt='' className='avatar-xxs' /> xmcc
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={xmg} alt='' className='avatar-xxs' /> xmg
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={xmo} alt='' className='avatar-xxs' /> xmo
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={xmr} alt='' className='avatar-xxs' /> xmr
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={xmy} alt='' className='avatar-xxs' /> xmy
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={xp} alt='' className='avatar-xxs' /> xp
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={xpa} alt='' className='avatar-xxs' /> xpa
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={xpm} alt='' className='avatar-xxs' /> xpm
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={xpr} alt='' className='avatar-xxs' /> xpr
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={xrp} alt='' className='avatar-xxs' /> xrp
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={xsg} alt='' className='avatar-xxs' /> xsg
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={xtz} alt='' className='avatar-xxs' /> xtz
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={xuc} alt='' className='avatar-xxs' /> xuc
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={xvc} alt='' className='avatar-xxs' /> xvc
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={xvg} alt='' className='avatar-xxs' /> xvg
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={xzc} alt='' className='avatar-xxs' /> xzc
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={yfi} alt='' className='avatar-xxs' /> yfi
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={yoyow} alt='' className='avatar-xxs' /> yoyow
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={zcl} alt='' className='avatar-xxs' /> zcl
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={zec} alt='' className='avatar-xxs' /> zec
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={zel} alt='' className='avatar-xxs' /> zel
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={zen} alt='' className='avatar-xxs' /> zen
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={zest} alt='' className='avatar-xxs' /> zest
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={zil} alt='' className='avatar-xxs' /> zil
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={zilla} alt='' className='avatar-xxs' /> zilla
                      </div>
                    </Col>
                    <Col xl={3} lg={4} sm={6}>
                      <div className='text-muted hstack gap-2'>
                        <img src={zrx} alt='' className='avatar-xxs' /> zrx
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default CryptoIcons;
